import {formatDateTime} from '../utils/formatDateTime';
import {getCurrentCompanyLocationId} from '../utils/getCurrentCompanyLocationId';

/*
* Chart 1 - Temperature and Rainfall/Snowfall.
* */
function drawChart1() {
    let currentCompanyId = getCurrentCompanyLocationId();
    let apiUrl = `/api/company-location/${currentCompanyId}/weather-forecast/hourly`;

    fetch(apiUrl)
        .then(response => {
            return response.json();
        })
        .then(dataChart => {
            const hours = dataChart.hours;

            /*
            * Box Date Range.
            * */
            const start = formatDateTime(hours[0].hour);
            const end = formatDateTime(hours[48].hour);
            const monthFirst = start.month + 1;
            const monthLast = end.month + 1;

            document.querySelector('.c-box-forecast-hours-chart .c-box__header__meta').innerHTML = `${start.day}.${monthFirst} - ${end.day}.${monthLast}.${end.year}`;

            let data = new google.visualization.DataTable();

            data.addColumn('datetime', 'Date');
            data.addColumn('number', 'Opady');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn('number', 'Temperature');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn({
                role: 'style',
                type: 'string'
            });

            let pointStyle = "point { size: 4; shape-type: circle; fill-color: #ffffff; opacity: 1; stroke-color: #ffcd00; stroke-width: 2}";

            let dataRows = [];
            for (let i = 0; i < 48; i++) {
                let dataRow = [];
                let dateTime = formatDateTime(hours[i].hour);
                let dataHour = new Date(dateTime.year, dateTime.month, dateTime.day, dateTime.hour);

                let fall = (hours[i].rain !== null) ? hours[i].rain : hours[i].snow;
                let fallLabel = (fall) ? `${fall} mm/h` : null;

                let temperature = hours[i].temperature;
                let temperatureLabel = `${temperature} \xB0`;

                dataRow.push(dataHour);
                dataRow.push(fall);
                dataRow.push(fallLabel);
                dataRow.push(temperature);
                dataRow.push(temperatureLabel);
                dataRow.push(pointStyle);

                dataRows.push(dataRow);
            }

            data.addRows(dataRows);

            let options = {
                legend: {
                    position: 'none'
                },
                backgroundColor: {
                    fill: '#fff',
                    fillOpacity: 1
                },
                chartArea: {
                    top: 10,
                    left: 50,
                    right: 50,
                    height: '80%',
                    width: '100%'
                },
                fontSize: 12,
                width: 3200,
                height: 300,
                series: {
                    // Opady
                    0: {
                        targetAxisIndex: 0,
                        color: '#81c5d3',
                        type: 'bars',
                    },
                    // Temperatura
                    1: {
                        targetAxisIndex: 1,
                        color: '#ffcd00',
                        type: 'line',
                    }
                },
                vAxes: {
                    0: {
                        title: "Opady",
                        gridlines: {
                            color: '#e5e5e5',
                            count: 5
                        },
                    },
                    1: {
                        title: "Temperatura",
                        gridlines: {
                            count: 0
                        },
                    }
                },
                annotations: {
                    alwaysOutside: true,
                    highContrast: true,
                    textStyle: {
                        fontSize: 11,
                        opacity: 1,
                        bold: true
                    }
                },
                hAxis: {
                    title: 'Wind',
                    format: 'H:mm',
                    gridlines: {
                        color: '#e5e5e5',
                    }
                },
                curveType: 'function',
                pointSize: 10,
                crosshair: {
                    trigger: 'both'
                }
            };

            let chart1 = new google.visualization.ComboChart(document.getElementById('c-box-forecast-hours-chart__chart--1'));

            chart1.draw(data, options);

        })
        .catch(err => {
            console.log('Problem with chart #2', err);
        });


}

/*
* Chart 2 - Wind and Pressure.
* */
function drawChart2() {
    let currentCompanyId = getCurrentCompanyLocationId();
    let apiUrl = `/api/company-location/${currentCompanyId}/weather-forecast/hourly`;

    fetch(apiUrl)
        .then(response => {
            return response.json();
        })
        .then(dataChart => {
            const hours = dataChart.hours;

            let data = new google.visualization.DataTable();

            data.addColumn('datetime', 'Date');
            data.addColumn('number', 'Ciśnienie');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn('number', 'Wiatr');
            data.addColumn({
                type: 'string',
                role: 'annotation'
            });
            data.addColumn({
                role: 'style',
                type: 'string'
            });

            let pointStyle = "point { size: 4; shape-type: circle; fill-color: #ffffff; opacity: 1; stroke-color: #ffcd00; stroke-width: 2}";

            let dataRows = [];
            for (let i = 0; i < 48; i++) {
                let dataRow = [];
                let dateTime = formatDateTime(hours[i].hour);
                let dataHour = new Date(dateTime.year, dateTime.month, dateTime.day, dateTime.hour);

                let pressure = hours[i].pressure;
                let pressureLabel = `${pressure} hPa`;

                let wind = hours[i].wind;
                let windLabel = `${wind} km/h`;

                dataRow.push(dataHour);
                dataRow.push(pressure);
                dataRow.push(pressureLabel);
                dataRow.push(wind);
                dataRow.push(windLabel);
                dataRow.push(pointStyle);

                dataRows.push(dataRow);
            }

            data.addRows(dataRows);

            // data.addRows([
            //     [new Date(2020, 5, 1, 1), 1021, '1021 hPa', 23, '23 kkm/h', pointStyle],
            //     [new Date(2020, 5, 1, 2), 1016, '1016 hPa', 22, '22 kkm/h', pointStyle],
            //     [new Date(2020, 5, 1, 3), 1012, '1012 hPa', 23, '23 kkm/h', pointStyle],
            //     [new Date(2020, 5, 1, 4), 966, '966 hPa', 21, '21 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 5), 970, '970 hPa', 26, '26 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 6), 1000, '1000 hPa', 27, '27 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 7), 970, '970 hPa', 29, '29 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 8), 990, '990 hPa', 19, '19 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 9), 1010, '1010 hPa', 19, '19 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 10), 1022, '1022 hPa', 21, '21 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 11), 1015, '1015 hPa', 22, '22 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 12), 999, '999 hPa', 25, '25 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 13), 1021, '1021 hPa', 23, '23 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 14), 1016, '1016 hPa', 22, '22 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 15), 1012, '1012 hPa', 23, '23 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 16), 966, '966 hPa', 21, '21 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 17), 970, '970 hPa', 26, '26 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 18), 1000, '1000 hPa', 27, '27 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 19), 970, '970 hPa', 29, '29 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 20), 990, '990 hPa', 19, '19 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 21), 1010, '1010 hPa', 19, '19 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 22), 1022, '1022 hPa', 21, '21 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 23), 1015, '1015 hPa', 22, '22 km/h', pointStyle],
            //     [new Date(2020, 5, 1, 24), 999, '999 hPa', 25, '25 km/h', pointStyle],
            //
            // ]);

            let options = {
                legend: {
                    position: 'none'
                },
                backgroundColor: {
                    fill: '#fff',
                    fillOpacity: 1
                },
                chartArea: {
                    top: 10,
                    left: 50,
                    right: 50,
                    height: '80%',
                    width: '100%'
                },
                fontSize: 12,
                width: 3300,
                height: 300,
                series: {
                    // Opady
                    0: {
                        targetAxisIndex: 0,
                        color: '#ffcd00',
                        type: 'line',
                    },
                    // Temperatura
                    1: {
                        targetAxisIndex: 1,
                        color: '#81c5d3',
                        type: 'bars',
                    }
                },
                vAxes: {
                    0: {
                        title: "Ciśnienie",
                        gridlines: {
                            color: '#e5e5e5',
                            count: 5
                        }
                    },
                    1: {
                        title: "Wiatr",
                        gridlines: {
                            color: '#e5e5e5',
                            count: 0
                        }
                    }
                },
                annotations: {
                    alwaysOutside: true,
                    highContrast: true,
                    textStyle: {
                        fontSize: 11,
                        opacity: 1,
                        bold: true
                    }
                },
                hAxis: {
                    // format: 'MM dd'
                    title: 'Wind',
                    // ticks: [
                    //     new Date(2020, 5, 1, 1, 0),
                    //     new Date(2020, 5, 1, 2, 0),
                    //     new Date(2020, 5, 1, 3, 0),
                    //     new Date(2020, 5, 1, 4, 0),
                    //     new Date(2020, 5, 1, 5, 0),
                    //     new Date(2020, 5, 1, 6, 0),
                    //     new Date(2020, 5, 1, 7, 0),
                    //     new Date(2020, 5, 1, 8, 0),
                    //     new Date(2020, 5, 1, 9, 0),
                    //     new Date(2020, 5, 1, 10, 0),
                    //     new Date(2020, 5, 1, 11, 0),
                    //     new Date(2020, 5, 1, 12, 0),
                    //     new Date(2020, 5, 1, 13, 0),
                    //     new Date(2020, 5, 1, 14, 0),
                    //     new Date(2020, 5, 1, 15, 0),
                    //     new Date(2020, 5, 1, 16, 0),
                    //     new Date(2020, 5, 1, 17, 0),
                    //     new Date(2020, 5, 1, 18, 0),
                    //     new Date(2020, 5, 1, 19, 0),
                    //     new Date(2020, 5, 1, 20, 0),
                    //     new Date(2020, 5, 1, 21, 0),
                    //     new Date(2020, 5, 1, 22, 0),
                    //     new Date(2020, 5, 1, 23, 0),
                    //     new Date(2020, 5, 1, 24, 0),
                    // ],
                    format: 'H:mm',
                    gridlines: {
                        color: '#e5e5e5',
                    }
                },

                curveType: 'function',
                pointSize: 10,
                crosshair: {
                    trigger: 'both'
                },
                tooltip: {
                    trigger: 'none'
                }
            };

            let chart2 = new google.visualization.ComboChart(document.getElementById('c-box-forecast-hours-chart__chart--2'));

            chart2.draw(data, options);

        })
        .catch(err => {
            console.log('Problem with chart #2', err);
        });
}
